/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FeaturesEnabled } from './FeaturesEnabled';
import {
    FeaturesEnabledFromJSON,
    FeaturesEnabledFromJSONTyped,
    FeaturesEnabledToJSON,
    FeaturesEnabledToJSONTyped,
} from './FeaturesEnabled';

/**
 * 
 * @export
 * @interface UpdateEnabledFeaturesResponse
 */
export interface UpdateEnabledFeaturesResponse {
    /**
     * 
     * @type {FeaturesEnabled}
     * @memberof UpdateEnabledFeaturesResponse
     */
    data: FeaturesEnabled;
}

/**
 * Check if a given object implements the UpdateEnabledFeaturesResponse interface.
 */
export function instanceOfUpdateEnabledFeaturesResponse(value: object): value is UpdateEnabledFeaturesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function UpdateEnabledFeaturesResponseFromJSON(json: any): UpdateEnabledFeaturesResponse {
    return UpdateEnabledFeaturesResponseFromJSONTyped(json, false);
}

export function UpdateEnabledFeaturesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateEnabledFeaturesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': FeaturesEnabledFromJSON(json['data']),
    };
}

  export function UpdateEnabledFeaturesResponseToJSON(json: any): UpdateEnabledFeaturesResponse {
      return UpdateEnabledFeaturesResponseToJSONTyped(json, false);
  }

  export function UpdateEnabledFeaturesResponseToJSONTyped(value?: UpdateEnabledFeaturesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': FeaturesEnabledToJSON(value['data']),
    };
}

